import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import { AiOutlineDownload } from "react-icons/ai";
import { CgWebsite } from "react-icons/cg";
import { profile } from "../../data/profile";
import { motion } from "framer-motion";

function ResumeNew() {
  const resumeUrl = profile.resume.url;

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Container>
          <Row style={{ justifyContent: "center", paddingTop: "10px" }}>
            <Col md={10} lg={9}>
              <motion.div
                className="resume-card"
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.35 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
              >
                <div className="resume-card-header">
                  <div>
                    <h1 className="resume-title">
                      Resume <span className="purple">{profile.name}</span>
                    </h1>
                    <p className="resume-subtitle">
                      Download or view the PDF version of my resume.
                    </p>
                  </div>
                  <div className="resume-actions">
                    <Button
                      className="btn-gradient"
                      href={resumeUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiOutlineDownload />
                      &nbsp;Download
                    </Button>
                    <Button
                      variant="outline-light"
                      className="btn-outline-neon"
                      href={resumeUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={{ marginLeft: "10px" }}
                    >
                      <CgWebsite />
                      &nbsp;View
                    </Button>
                  </div>
                </div>

                <div className="resume-preview">
                  <iframe
                    title="Resume preview"
                    src={resumeUrl}
                    className="resume-iframe"
                  />
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default ResumeNew;
